export function handleError(error: any): void {
  alert(`Ошибка: ${error.message}`);
  // eslint-disable-next-line no-console
  console.log(error);
}
